import css from './CheckedItemRow.module.css';
import CheckboxInput from '@shared/Ui/CustomInputs/CheckboxInput/CheckboxInput';
import { FormatNumber } from '@shared/Helpers/FormatValue/FormatNumber/FormatNumber';
import { CheckedItem } from '@modules/Steps/Shared/Interfaces/CheckedItem';
import { ItemsSelectionViewModel } from '@viewModels/ItemsSelectionViewModel/ItemsSelectionViewModel';
import { useItemsSelectionStore } from '../../../../../../../../Stores/ItemsSelectionStore';
import { IsItemSelected } from '@viewModels/ItemsSelectionViewModel/Services/IsItemSelected';
import { GetItemUnit } from '@modules/Steps/Shared/Helpers/GetItemUnit';

interface Props {
    item: CheckedItem;
}

export const CheckedItemRow = ({ item }: Props) => {
    const { title, qty, price, uuid } = item.item;

    const selectedItemsViewModel = new ItemsSelectionViewModel();
    const { selectedItems } = useItemsSelectionStore();

    const isSelected = IsItemSelected(uuid, selectedItems);

    const total =
        typeof qty === 'number' && price ? qty * Number(price) : Number(price);

    const handleToggleSelectItem = () => {
        selectedItemsViewModel.toggleSelectItem(item.item);
    };

    return (
        <div className={css.tableRow}>
            <div className={css.itemCell}>
                <CheckboxInput
                    checked={isSelected}
                    onChange={handleToggleSelectItem}
                    disabled={item.isLabour}
                />
                {title}
            </div>

            <div className={css.qty}>{GetItemUnit(item.item)}</div>

            <div className={css.price}>
                <span>R {FormatNumber(price!, '0.00')}</span>
            </div>

            <div className={css.total}>
                <span>R {FormatNumber(total, '0.00')}</span>
            </div>
        </div>
    );
};
